import React from 'react'
import PropTypes from 'prop-types'
import { Typography, Box } from '@material-ui/core'

const LabelInput = ({
  label,
  children,
  required = false,
  className = 'w-full',
  infoComponent = null,
}) => {
  return (
    <Box mb={2} className={className}>
      <Typography
        variant="subtitle1"
        gutterBottom
        className="text-14 font-bold text-primary flex items-center"
      >
        {label}
        {infoComponent && infoComponent}
        {required && <span className="px-2">{'*'}</span>}
      </Typography>
      {children}
    </Box>
  )
}

LabelInput.propTypes = {
  required: PropTypes.bool,
  className: PropTypes.string,
  infoComponent: PropTypes.node,
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
}

export default LabelInput
